// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1g6Iu","upload":"Small_upload__QLiBC","imageWrap":"Small_imageWrap__19gSI","removeBtn":"Small_removeBtn__1tsg9"};